import styled from 'styled-components';
import { VerifiedIcon } from '../assets';
import Avatar from '../avatar/Avatar';
import Button from '../button/Button';
import Typography from '../typography/Typography';
export const UserDetailsContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
`;
export const UserDetailsInfo = styled.div `
  display: flex;
  align-items: center;
`;
export const UserDetailsTextWrapper = styled.div `
  display: flex;
  flex-direction: column;

  margin-left: 1.1rem;
`;
export const UserPhone = styled(Typography) `
  margin-left: 1.8rem;
`;
export const ProfileButton = styled(Button) `
  width: 18rem;
  max-width: 40%;

  height: auto;
  min-height: 4.2rem;

  padding: 0.5rem;

  ${({ theme }) => theme.media.mobileL `
    padding: 1rem 0;
    
  `};
`;
export const CustomVerifiedIcon = styled(VerifiedIcon) `
  position: absolute;
  bottom: -0.4rem;
  right: -0.4rem;
`;
export const SecondaryInfo = styled.div `
  display: flex;

  align-items: center;

  white-space: break-spaces;
`;
export const CustomAvatar = styled(Avatar) `
  color: ${({ theme }) => theme.colors.text.interactive};
`;
export const ImageWrapper = styled.div `
  position: relative;
`;
//# sourceMappingURL=styles.js.map